import { Link } from 'react-router-dom'

interface StartSessionProps {
  location: string
  url: string
  text: string
  className?: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}
export default function StartSession({
  location,
  className = '',
  url,
  text,
  onClick,
}: StartSessionProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      onClick(e)
    }
  }

  return (
    <Link
      to={url}
      className={`start-experience-btn ${className}`}
      state={{ prevLocation: location }}
      onClick={handleClick}
    >
      <span className="button-content">
        <span className="star-icon star-first">✦</span>
        <span className="star-icon star-second large">✦</span>
        <span className="star-icon star-third">✦</span>
        <span className="text ms-2">{text}</span>
      </span>
    </Link>
  )
}
